<template>
  <v-row>
    <v-col cols="2" class="pr-0 mr-0">
      <v-avatar
          class="mt-7"
          size="50px"
      >
        <img
            alt="Avatar"
            :src="require('@/assets/img_perfil.png')"
        >
      </v-avatar>
    </v-col>

    <v-col cols="10">
      <p class="caption py-0 my-0 mt-8" v-html="name"></p>
      <p class="caption py-0 my-0" v-html="$t('lblEditarPerfil')"></p>
    </v-col>
  </v-row>
</template>
<script>
// Internacionalización. Para la presentación de mensajes en diferentes idiomas
import i18nMessages from "./i18n/messages";

//let thisComponent = null;
export default {
  // Asignamos los mensajes del módulo al framework i18n, para el manejo del idioma
  i18n: i18nMessages,
  data() {
    //thisComponent = this;
    return {
      name: 'Usuairo',
      moduleName: 'AVATAR',
    };
  },


};
</script>
